import { CoreRankingsRow } from '../../../views';
import teamplate from './index.jst';
import './index.styl';
import { ViewOthersTeamsLayout } from '../../index';

/**
 * @desc RankingsTipping Row Class
 * This class using on league loin page ('fantasy/team/rankings')
 */
export class RankingsRow extends CoreRankingsRow {
	get template () {
		return teamplate;
	}

	viewTeam( element ) {
		$(element.currentTarget).toggleClass('close');

		if( !this.getRegion('view_team').hasView() ) {
			let {
				current_round,
				team_id,
				user_id,
				current_round_league_points,
				// overall_rank,
				points,
				rank
			} = this.model.attributes;
			let viewOthersTeams = new ViewOthersTeamsLayout( {
				current_round,
				team_id,
				user_id,
				round_points: current_round_league_points,
				overall_rank: false,
				overall_points: points,
				rank
			} );
			this.getRegion( 'view_team' ).show( viewOthersTeams );
		}
		else {
			this.getRegion( 'view_team' ).empty();
		}
	}
}

export default RankingsRow;